<template>
  <b-row>
    <b-col
        v-for="(question, index) in questions"
        :key="index"
        :cols="numCol === null ? 12 : numCol"
    >
      <div v-if="selectedQuestion.uuid === question.uuid">
        <SurveyBuilder :options="selectedQuestion"></SurveyBuilder>
      </div>
      <div v-if="selectedQuestion.uuid !== question.uuid" class="border p-3">
        <div class="float-right">
          <i
              class="fas fa-trash-alt text-danger cursor-point"
              v-on:click="deleteQuestion(question, index)"
          ></i>
        </div>
        <div class="p-0">
          <div class="question-section">
            <p class="question_body">{{ question.body }}</p>
          </div>
          <div class="answer-section">
            <div v-if="question.type === 'BOOLEAN'" class="option-section">
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio
                    v-for="(option, index) in question.options"
                    :key="index"
                    v-model="question.value"
                    :aria-describedby="ariaDescribedby"
                    :disabled="readOnly"
                    :name="'booleanSelect' + question.uuid"
                    :value="option.sequence"
                >{{ option.body }}
                </b-form-radio>
              </b-form-group>
            </div>
            <div v-if="question.type === 'TEXT'" class="option-section">
              <b-form-input
                  v-if="question.characterLimited"
                  v-model="question.value"
                  :maxlength="question.textLimit"
                  :readonly="readOnly"
                  min="0"
                  type="text"
              />
              <b-form-input
                  v-if="!question.characterLimited"
                  v-model="question.value"
                  :readonly="readOnly"
                  type="text"
              />
            </div>
            <div v-if="question.type === 'FILE'" class="option-section">
              <vue-dropzone
                  :id="'dropzone' + question.uuid"
                  :options="dropzoneOptions"
                  @vdropzone-success="vdropzoneSuccess(question, ...arguments)"
              ></vue-dropzone>
            </div>
            <div v-if="question.type === 'DATE'" class="option-section">
              <date-picker
                  v-model="question.valueTmp"
                  :format="myFormat"
                  :formatter="momentFormat"
                  :readonly="readOnly"
                  type="date"
                  @pick="updateDate(question)"
              ></date-picker>
            </div>
            <div v-if="question.type === 'TIME'" class="option-section">
              <vue-timepicker
                  v-model="question.valueTmp"
                  :readonly="readOnly"
                  @change="updateTime(question)"
              ></vue-timepicker>
            </div>
            <div v-if="question.type === 'NUMBER'" class="option-section">
              <div>
                <b-form-input
                    v-if="question.hasMinMax && !question.allowDecimals"
                    v-model="question.value"
                    :max="question.maxValue"
                    :min="question.minValue"
                    :readonly="readOnly"
                    type="range"
                >
                  {{ question.value }}
                </b-form-input>
                <b-form-input
                    v-if="!question.hasMinMax && question.allowDecimals"
                    v-model="question.value"
                    :readonly="readOnly"
                    step="0.01"
                    type="number"
                >
                </b-form-input>
                <b-form-input
                    v-if="!question.hasMinMax && !question.allowDecimals"
                    v-model="question.value"
                    :readonly="readOnly"
                    type="number"
                >
                </b-form-input>
                <b-form-input
                    v-if="question.hasMinMax && question.allowDecimals"
                    v-model="question.value"
                    :max="question.maxValue"
                    :min="question.minValue"
                    :readonly="readOnly"
                    step="0.01"
                    type="range"
                >
                </b-form-input>
                <div v-if="question.hasMinMax">
                  {{ question.value }}
                </div>
              </div>
            </div>
            <div
                v-if="question.type === 'SINGLE_CHOICE'"
                class="option-section"
            >
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio
                    v-for="(option, index) in question.options"
                    :key="index"
                    v-model="question.value"
                    :aria-describedby="ariaDescribedby"
                    :disabled="readOnly"
                    :value="option.body"
                    name="singleSelect"
                >{{ option.body }}
                </b-form-radio
                >
              </b-form-group>
            </div>
          </div>
          <div v-if="question.type === 'TEXTAREA'" class="option-section">
            <b-form-textarea
                :id="'textarea' + question.uuid"
                v-model="question.value"
                max-rows="6"
                rows="3"
            ></b-form-textarea>
          </div>
          <div v-if="question.type === 'RATING'" class="option-section">
            <b-form-rating
                :id="'rating' + question.uuid"
                v-model="question.value"
                variant="warning"
            ></b-form-rating>
          </div>
          <div v-if="question.type === 'EDITOR'" class="option-section">
            <ckeditor
                v-model="question.value"
                :config="configCK"
                type="classic"
            ></ckeditor>
          </div>
          <div v-if="question.type === 'MULTI_CHOICE'" class="option-section">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group
                  v-model="question.valueTmp"
                  @input="multiChoiceTransformJson(question)"
              >
                <b-form-checkbox
                    v-for="(option, index) in question.options"
                    :key="index"
                    :aria-describedby="ariaDescribedby"
                    :name="'multiChoiceSelect' + question.uuid"
                    :value="option.sequence"
                >{{ option.body }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </div>
          <div v-if="question.type === 'CORE'" class="option-section">
            <b-form-group>
              <b-form-group v-slot="{ ariaDescribedby }">
                <span v-if="question.coreWeight !== undefined"
                >( {{ question.coreWeight }} )</span
                >
                <b-form-radio
                    v-for="(option, index) in question.options"
                    :key="index"
                    v-model="question.value"
                    :aria-describedby="ariaDescribedby"
                    :disabled="readOnly"
                    :name="'coreSelect' + question.uuid"
                    :value="option.weight"
                >{{ option.body }}
                  <span v-if="option.weight !== undefined"
                  >( {{ option.weight }} )</span
                  >
                </b-form-radio>
              </b-form-group>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import SurveyBuilder from "./SurveyBuilder";

import FiveOptionsCoreSelect from "../../json/FiveCoreOptions";

import moment from "moment";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  name: "QuestionsView",
  data() {
    return {
      numCol: "12",
      numColSelect: [
        {
          value: "12",
          text: "1 columna",
        },
        {
          value: "6",
          text: "2 columna",
        },
        {
          value: "4",
          text: "3 columna",
        },
      ],
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
      },
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
      fiveOptionsCoreSelect: FiveOptionsCoreSelect,
      selectedQuestion: {id: null},
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
    };
  },
  props: ["questions", "readOnly"],
  components: {SurveyBuilder, DatePicker, VueTimepicker},
  mounted() {
    this.$root.$on("selected-question", (obj) => {
      this.selectedQuestion = {id: null};
    });
  },
  computed: {},
  watch: {},
  methods: {
    changeNumColumn() {
      this.$root.$emit("change-colums", this.numCol);
    },
    multiChoiceTransformJson(question) {
      if (question.valueTmp && question.type === "MULTI_CHOICE") {
        question.value = JSON.stringify(question.valueTmp);
      }
    },
    updateTime(question) {
      if (question.valueTmp) {
        question.value = question.valueTmp.HH + ":" + question.valueTmp.mm;
      }
    },
    updateDate(question) {
      question.value = moment(question.valueTmp).format("DD/MM/yyyy");
    },
    vdropzoneSuccess: function (question, file, response) {
      question.value = response.uuid;
    },
    editQuestion(question, index) {
      this.selectedQuestion = JSON.parse(JSON.stringify(question));
      this.selectedQuestion.questionNumber = index + 1;
    },
    deleteQuestion(question, index) {
      this.questions.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
$color-primary: #f8f8f8;
$color-secondary: #eaf0f4;
$color-blue: #4c8ce4;
$color-orange: #ff9635;
$color-red: #f06559;
$color-green: #48bf7a;
h1,
h2,
h3 {
  font-weight: 200;
}

.wid300 {
  max-width: 300px !important;
}

.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.question_body {
  word-break: break-all;
  color: #555;
}

.read-only-question {
  background-color: #fafafa;
}

.icon-style {
  color: #57dd7a;
  font-size: 25px;
  padding-top: 20px;
  background-color: #d6f0de;
  padding: 7px;
  padding-bottom: 3px;
  border-radius: 25px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

.text-style {
  color: #969090;
  text-align: right;
}

.btn-style {
  margin-top: 10px;
  width: 80px;
  height: 29px;
  margin-bottom: 50px;
}

button {
  cursor: pointer;
}

.custom-btn {
  background: #00baf9;
  color: #fff;
  width: 220px;
}

.pad-top50 {
  padding-top: 50px;
}

.form-control {
  border-radius: 2px;
}

.custom-para {
  padding-bottom: 20px;
  font-size: 20px;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.readonly {
  background: #f7f7f7;
}

.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}

.text-color {
  color: #888;
}

.survey-name {
  color: #00baf9;
  font-size: 20px;
}

.pad-left50 {
  padding-left: 50px;
}

.branching_section {
  background-color: #f5f8fa;
  border: solid 1px #d3dfe4;
  padding: 5px 10px;

  .branching_image {
    max-width: 120px;
    max-height: 120px;
    width: 100%;
    border: 1px solid #ccc;
  }
}

.custom-btn-bg {
  background: linear-gradient(to left, #4b6fe6, #00baf9);
  color: #fff;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.pad-left100 {
  padding-left: 100px;
}

.mar-bot0 {
  margin-bottom: 0px !important;
}

.card {
  border: 1px solid rgba(0, 0, 0, 0.125);
  margin-bottom: 24px;
}

.question_color,
input {
  color: #555;
  font-size: 16px;
}

p {
  margin: 8px 0;
}

.radio-option {
  margin: 0px;
}

.input-text {
  width: 100%;
  border-radius: 2px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.DATE-input {
  border-radius: 20px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.pad-top20 {
  padding-top: 20px;
}

.img-size {
  width: 100%;
  height: auto;
  float: none;
  padding: 10px 0 0;
  max-width: 120px;
  max-height: 120px;
}

label {
  font-weight: normal !important;
  word-break: break-all;
  color: #555;
}

.modal-dialog {
  width: 500px !important;
}

.width-90 {
  width: 90% !important;
}

.sb-btn-link {
  border: none;
  background: none;
  padding: 5px;
  color: #f06559;
  font-size: 14px;
  margin-top: 16px;
}

.color-blue {
  color: $color-blue;
}

.color-orange {
  color: $color-orange;
}

.color-red {
  color: $color-red;
}

.color-green {
  color: $color-green;
}

.slidecontainer {
  width: 100%;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 25px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: #4caf50;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #4caf50;
  cursor: pointer;
}
</style>
